export interface BridgePainPoint {
  emoji: string;
  text: string;
  variant: 'negative' | 'positive';
}

export interface BridgeScreenConfig {
  layout?: "default" | "compact";
  sectionLabel: string;
  headline: {
    prefix: string;
    highlighted: string;
  };
  subheadline: string;
  painPoints: BridgePainPoint[];
  socialProof?: {
    emoji: string;
    count: string;
    text: string;
  };
  cta: string;
}

export const BRIDGE_CONTENT: Record<string, BridgeScreenConfig> = {
  cut_bodyfat: {
    sectionLabel: "YOUR STARTING POINT",
    headline: {
      prefix: "Stuck at the same body fat",
      highlighted: "no matter what you do?",
    },
    subheadline:
      "You're not alone. Most people plateau here because generic plans don't account for what <strong>actually matters</strong>.",
    painPoints: [
      {
        emoji: "\u{1F624}",
        text: "Eating less but not getting leaner",
        variant: "negative",
      },
      {
        emoji: "\u{1F504}",
        text: "Losing muscle instead of fat",
        variant: "negative",
      },
      {
        emoji: "\u2705",
        text: "We'll build a plan that helps you drop fat while building muscle",
        variant: "positive",
      },
    ],
    socialProof: {
      emoji: "\u{1F4AA}",
      count: "110,247",
      text: "people have used BWS+ to break through plateaus",
    },
    cta: "Build My Custom Plan",
  },
  cut_bodyfat2: {
    layout: "compact",
    sectionLabel: "Your Starting Point",
    headline: {
      prefix: "Struggling To Drop Body Fat",
      highlighted: "No Matter What You Do?",
    },
    subheadline:
      "You&rsquo;re not alone. It&rsquo;s time you finally get the results that match your effort with a personalized plan built on science.",
    painPoints: [],
    cta: "Build My Custom Plan",
  },
  cut_bodyfat3: {
    layout: "compact",
    sectionLabel: "Your Starting Point",
    headline: {
      prefix: "Not Enough Muscle To Cut",
      highlighted: "But Too Much Fat To Bulk?",
    },
    subheadline:
      "You&rsquo;re not alone. It&rsquo;s time you finally get results that match your effort with a personalized plan built on science.",
    painPoints: [],
    cta: "Build My Custom Plan",
  },
};
